export default "__VITE_ASSET__e240b7ff__"